<template>
    <v-sheet
        id="step-body"
        class="overflow-y-auto overflow-x-hidden pt-1 pb-3"
        :max-height="maxHeight"
    >
        <div class="mx-6">
            <LastStep
                v-if="isLastStep"
                :isDownloadSuccess="isDownloadSuccess && !isImportOperation"
                :isImportSuccess="isDownloadSuccess && isImportOperation"
                :isAProgram="isAProgram"
            />
            <StepMedia
                v-else-if="step.id === 'step_1'"
                :subtitle="step.subtitle"
                :description="step.description"
                :forms="filteredForms"
                :selectedMedia="selectedValues['media']"
            />
            <StepFormat
                v-else-if="step.id === 'step_2'"
                :subtitle="step.subtitle"
                :description="step.description"
                :forms="filteredForms"
                :selectedFormat="selectedValues['format']"
            />
            <StepPersonnalization
                v-else-if="step.id === 'step_3'"
                :subtitle="step.title"
                :description="step.description"
                :filteredForms="filteredForms"
                :selectedValue="{
                    'media': selectedValues['media'],
                    'color': selectedValues['color'],
                    'quality': selectedValues['quality'],
                    'preset': selectedValues['preset'],
                    'mention': selectedValues['mention']
                }"
                :defaultQuality="defaultQuality"
                :defaultsPresetValues="defaultsPresetValues"
                @set-properties="setAdvancedPresetProperties"
                @update-disclaimer="updateDisclaimer"
            />
            <StepExport
                v-else-if="step.id === 'step_4' && !isLastStep"
                :step="step"
                :steps="steps"
                :selectedValues="selectedValues"
                :programName="programName"
                :widgetName="widgetName"
                :isAProgram="isAProgram"
                @select-step="selectStep"
            />
        </div>

    </v-sheet>
</template>

<script>
    import StepMedia from '@/components/myHabiteoStudio/steps/StepMedia';
    import StepFormat from '@/components/myHabiteoStudio/steps/StepFormat';
    import StepPersonnalization from '@/components/myHabiteoStudio/steps/StepPersonnalization';
    import StepOptions from '@/components/myHabiteoStudio/steps/StepOptions';
    import StepExport from '@/components/myHabiteoStudio/steps/StepExport';
    import LastStep from '@/components/myHabiteoStudio/steps/LastStep';

    export default {
        data () {
            return {
                bodyHeight: "470px"
            }
        },
        name: 'Steps',
        components: {
            StepMedia,
            StepFormat,
            StepPersonnalization,
            StepOptions,
            StepExport,
            LastStep
        },
        props: {
            selectedValues: {
                type: Object,
                required: true
            },
            step: {
                type: Object,
                required: true
            },
            steps: {
                type: Array,
                required: true
            },
            isDownloadStep: {
                type: Boolean,
                required: true
            },
            isDownloadSuccess: {
                required: true
            },
            isImporting: {
                type: Boolean,
                required: true
            },
            isImportOperation: {
                type: Boolean,
                required: true
            },
            widgetName: {
                type: String,
                required: true
            },
            programName: {
                type: String,
                required: true
            },
            isAProgram: {
                type: Boolean,
                required: true
            },
            defaultQuality: {
                type: String,
                required: true
            },
            defaultsPresetValues: {
                type: String,
                required: true
            }
            
        },
        computed: {
            filteredForms() {
                return this.$props.step.forms
            },
            isLastStep() {
                return this.$props.isDownloadStep && this.$props.isDownloadSuccess !== null;
            },
            maxHeight() {
                return this.isDownloadSuccess || this.isImporting ? "100%" : `calc(100% - ${this.step.id === 'step_4' ? 210 : 160}px)`;
            }
        },
        methods: {
            setAdvancedPresetProperties(type, value) {
                this.$emit('set-properties', type, value);
            },
            selectStep(step) {
                this.$emit('select-step', step);
            },
            updateDisclaimer() {
                this.$emit('update-disclaimer');
            },
            setProperties(type, value) {
                this.$emit('set-properties', type, value);
            }
        },
        watch: {
            step() {
                this.bodyHeight = document.getElementById('mediaExportForm').offsetHeight - (document.getElementById('step-footer').offsetHeight + document.getElementById('step-summary').offsetHeight);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/Steps.vue